import * as yup from 'yup';

export const initialValues = {
  /* Superseded by getBIF */
  restaurant_name: '',
  restaurant_address: '',
  owner_name: '',
  owner_phone: '',
  account_holder_name: '',
  legal_address: '',
  routing_number: '',
  account_number: '',
  restaurant_email: '',
};

export const validationSchema = yup.object().shape({
  restaurant_name: yup.string().required('Please fill in restaurant name.'),
  restaurant_address: yup
    .string()
    .required('Please fill in restaurant address.'),
  owner_name: yup.string().required('Please fill in owner name.'),
  owner_phone: yup
    .string()
    .matches(/^[0-9]+$/, 'Owner Phone must be numeric.')
    .min(10, 'Owner Phone must be 10 digits.')
    .max(10, 'Owner Phone must be 10 digits.')
    .required('Please fill in owner phone.'),
  account_holder_name: yup
    .string()
    .required('Please fill in account holder name.'),
  legal_address: yup.string().required('Please fill in legal address.'),
  routing_number: yup
    .string()
    .test(
      'includes-stars',
      'Please re-type your routing number.',
      (value) => !value?.includes('*'),
    )
    .matches(/^[0-9]+$/, 'Routing Number must be numeric.')
    .min(9, 'Routing Number must be 9 digits.')
    .max(9, 'Routing Number must be 9 digits.')
    .required('Please fill in routing number.'),
  account_number: yup
    .string()
    .test(
      'is-not-stars',
      'Please re-type your account number.',
      (value) => !value?.includes('*'),
    )
    .matches(/^[0-9]+$/, 'Account Number must be numeric.')
    .min(5, 'Account Number must be at least 5 digits.')
    .required('Please fill in account number.'),
  restaurant_email: yup
    .string()
    .email('Please enter a valid email address.')
    .required('Please fill in restaurant email.'),
});
